import {createAction, props} from "@ngrx/store";
import {PaginatedRequestModel} from "@core/model/paginated-request.model";
import {RoleModel} from "@core/model/aux/role.model";
import {PaginatedResultModel} from "@core/model/paginated-result.model";
import {PermissionModel} from "@core/model/aux/permission.model";
import {AppUserModel} from "@core/model/aux/app-user.model";

export const LOAD_ROLES = '[User Roles] Load Roles';
export const LOAD_ROLES_SUCCESS = '[User Roles] Load Roles Success';
export const LOAD_ROLES_ERROR = '[User Roles] Load Roles Error';

export const ASSIGN_ROLE_TO_USER = '[User Roles] Assign Role To User';
export const ASSIGN_ROLE_TO_USER_SUCCESS = '[User Roles] Assign Role To User Success';
export const ASSIGN_ROLE_TO_USER_ERROR = '[User Roles] Assign Role To User Error';

export const LOAD_ROLE_DETAILS = '[User Roles] Load Role Details';
export const LOAD_ROLE_DETAILS_SUCCESS = '[User Roles] Load Role Details Success';
export const LOAD_ROLE_DETAILS_ERROR = '[User Roles] Load Role Details Error';

export const LOAD_PERMISSIONS = '[User Roles] Load Permissions';
export const LOAD_PERMISSIONS_SUCCESS = '[User Roles] Load Permissions Success';
export const LOAD_PERMISSIONS_ERROR = '[User Roles] Load Permissions Error';

export const SAVE_ROLE = '[User Roles] Save Role';
export const SAVE_ROLE_SUCCESS = '[User Roles] Save Role Success';
export const SAVE_ROLE_ERROR = '[User Roles] Save Role Error';

export const UPDATE_ROLE = '[User Roles] Update Role';
export const UPDATE_ROLE_SUCCESS = '[User Roles] Update Role Success';
export const UPDATE_ROLE_ERROR = '[User Roles] Update Role Error';

export const DELETE_ROLE = '[User Roles] Delete Role';
export const DELETE_ROLE_SUCCESS = '[User Roles] Delete Role Success';
export const DELETE_ROLE_ERROR = '[User Roles] Delete Role Error';

export const LOAD_USERS = '[Users] Load Users';
export const LOAD_USERS_SUCCESS = '[Users] Load Users Success';
export const LOAD_USERS_ERROR = '[Users] Load Users Error';


export const loadRoles = createAction(
  LOAD_ROLES,
  props<{ params: PaginatedRequestModel }>()
);

export const loadRolesSuccess = createAction(
  LOAD_ROLES_SUCCESS,
  props<{ response: PaginatedResultModel<RoleModel> }>()
);

export const loadRolesError = createAction(
  LOAD_ROLES_ERROR,
  props<{ msg: string }>()
);

export const loadUsers = createAction(
  LOAD_USERS
);

export const loadUsersSuccess = createAction(
  LOAD_USERS_SUCCESS,
  props<{ users: AppUserModel[] }>()
);

export const loadUsersError = createAction(
  LOAD_USERS_ERROR,
  props<{ msg: string }>()
);

export const loadRoleDetails = createAction(
  LOAD_ROLE_DETAILS,
  props<{ role: RoleModel }>()
);

export const loadRoleDetailsSuccess = createAction(
  LOAD_ROLE_DETAILS_SUCCESS,
  props<{ role: RoleModel }>()
);

export const loadRoleDetailsError = createAction(
  LOAD_ROLE_DETAILS_ERROR,
  props<{ msg: string }>()
);

export const loadPermissions = createAction(
  LOAD_PERMISSIONS,
  props<{ params: PaginatedRequestModel }>()
);

export const loadPermissionsSuccess = createAction(
  LOAD_PERMISSIONS_SUCCESS,
  props<{ permissions: PermissionModel[] }>()
);

export const loadPermissionsError = createAction(
  LOAD_PERMISSIONS_ERROR,
  props<{ msg: string }>()
);

export const saveRole = createAction(
  SAVE_ROLE,
  props<{ role: RoleModel }>()
);

export const saveRoleSuccess = createAction(
  SAVE_ROLE_SUCCESS,
  props<{ role: RoleModel }>()
);

export const saveRoleError = createAction(
  SAVE_ROLE_ERROR,
  props<{ msg: string }>()
);

export const updateRole = createAction(
  UPDATE_ROLE,
  props<{ role: RoleModel }>()
);

export const updateRoleSuccess = createAction(
  UPDATE_ROLE_SUCCESS,
  props<{ role: RoleModel }>()
);

export const updateRoleError = createAction(
  UPDATE_ROLE_ERROR,
  props<{ msg: string }>()
);

export const deleteRole = createAction(
  DELETE_ROLE,
  props<{ role: RoleModel }>()
);

export const deleteRoleSuccess = createAction(
  DELETE_ROLE_SUCCESS
);

export const deleteRoleError = createAction(
  DELETE_ROLE_ERROR,
  props<{ msg: string }>()
);

export const assignRoleToUser = createAction(
  ASSIGN_ROLE_TO_USER,
  props<{ user: AppUserModel }>()
);

export const assignRoleToUserSuccess = createAction(
  ASSIGN_ROLE_TO_USER_SUCCESS,
  props<{ user: AppUserModel }>()
);

export const assignRoleToUserError = createAction(
  ASSIGN_ROLE_TO_USER_ERROR,
  props<{ msg: string }>()
);
